import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bar"]
  static values = { threshold: { type: Number, default: 100 } }

  connect() {
    this.ticking = false
    this.visible = false
    this.navbar = document.querySelector(".app-navbar")
    this.scrollHandler = this.onScroll.bind(this)
    window.addEventListener("scroll", this.scrollHandler, { passive: true })
    this.onScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.scrollHandler)
    // Restore navbar on disconnect
    if (this.navbar) {
      this.navbar.style.transform = ""
      this.navbar.style.opacity = ""
    }
  }

  onScroll() {
    if (!this.ticking) {
      requestAnimationFrame(() => {
        this.update()
        this.ticking = false
      })
      this.ticking = true
    }
  }

  update() {
    if (!this.hasBarTarget) return

    if (window.scrollY > this.thresholdValue) {
      if (!this.visible) {
        // Show sticky search
        this.barTarget.style.transform = "translateY(0)"
        this.barTarget.style.opacity = "1"
        // Hide navbar
        if (this.navbar) {
          this.navbar.style.transform = "translateY(-100%)"
          this.navbar.style.opacity = "0"
        }
        this.visible = true
      }
    } else {
      if (this.visible) {
        // Hide sticky search
        this.barTarget.style.transform = "translateY(-100%)"
        this.barTarget.style.opacity = "0"
        // Show navbar
        if (this.navbar) {
          this.navbar.style.transform = "translateY(0)"
          this.navbar.style.opacity = "1"
        }
        this.visible = false
      }
    }
  }
}
